export class InterfaceInstanceTranslate {
    constructor(data) {
        this.instances = new Map();
        this.operatorsIds = new Map();
        this.rawData = data;
        data.forEach(d => {
            this.instances.set(d.rcsbId, d.asymIds);
            this.operatorsIds.set(d.rcsbId, d.operatorIds);
        });
    }
    getInstances(rcsbId) {
        return this.instances.get(rcsbId);
    }
    getOperatorIds(rcsbId) {
        return this.operatorsIds.get(rcsbId);
    }
    getRawData() {
        return this.rawData;
    }
}
//# sourceMappingURL=InterfaceInstanceTranslate.js.map